
























import { Component, Vue } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import * as ins_user_info_types from "@/store/constants/ins_user_info_types";
import * as setting_types from "@/store/constants/setting_types";
import * as cg_user_types from "@/store/constants/cg_user_types";
import NavBar from "@/components/NavBarNew/NavBar.vue";
import Scroller from "@/components/Scroller/Scroller.vue";
import MoreUserInfo from "./MoreUserInfo/MoreUserInfo.vue";
import MoreEntrance from "./MoreEntrance/MoreEntrance.vue";
import AndroidMoreEntrance from "./MoreEntrance/AndroidMoreEntrance.vue";
import VipEntrance from "./VipEntrance/VipEntrance.vue";
import { goToLogin, goToVip } from "@/utils/router_helper";
import { isVip } from "@/utils/general_utils";
import { isIos } from "@/utils/lodash";
import * as cgConst from "@/api/cg/base/cg_const";
import WebSessionStorageWorker from "@/utils/nativeStorage/web_session_storage";

@Component({
  components: {
    NavBar,
    Scroller,
    MoreUserInfo,
    MoreEntrance,
    VipEntrance,
    AndroidMoreEntrance
    // RecommenedList
  }
})
export default class MoreContainer extends Vue {
  @Getter(ins_user_info_types.GETTER_INS_USER_INFO_LIST)
  private userInfoList: any;
  @Getter(setting_types.GETTER_CLIENT_SETTINGS)
  private clientSetting: any;
  @Action(cg_user_types.UPDATE_VIP_PACKAGE_STATUS)
  private updateVipPackageStatus: any;
  @Action(setting_types.UPDATE_GX_SETTING_DATA)
  private updateSetting: any;

  private isVip: boolean = false;

  get isIOS() {
    return isIos();
  }

  private toSetting() {
    this.$router.push({
      name: "Setting",
      query: {
        routerTransition: "forward"
      }
    });
  }

  private clickUser() {
    if (this.userInfoList.length <= 0) {
      goToLogin();
    } else {
      this.$router.push({
        name: "ManageAccount",
        query: {
          routerTransition: "forward"
        }
      });
    }
  }
  private showVipPage() {
    WebSessionStorageWorker.set("is_has_show_vip_cell", "show");
    goToVip("tab5_icon");
  }

  // 切换到tab5时判断是否需要跳转到vip弹窗
  private async judgeWhetherGoVip() {
    const hasShowVip = WebSessionStorageWorker.has("is_has_show_vip_cell");
    // 如果没有显示过vip并且满足三分之一的概率下，显示vip部分
    if (
      !this.isVip &&
      this.clientSetting &&
      !hasShowVip &&
      Math.random() * 3 > 2
    ) {
      WebSessionStorageWorker.set("is_has_show_vip_cell", "show");
    }
  }

  private async created() {
    this.isVip = isVip();
    await this.updateVipPackageStatus();
  }

  private activated() {
    this.isVip = isVip();
    this.judgeWhetherGoVip();
    // 如果是VIP，为了避免用户直接切换到tab5，vippackage offer没有拉取到，再次拉取数据
    if (this.isVip) {
      this.updateSetting(cgConst.TAB_COIN_STORE_KEYS);
    }
  }
}
